import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Tabs, Tab, Box } from "@mui/material";
import axios from "axios";
import PaymentCheckoutCritical from "../../../components/Payment/PaymentCheckoutCritical";
import PaymentCheckoutSocial from "../../../components/Payment/PaymentCheckoutSocial";
import PaymentCheckoutLost from "../../../components/Payment/PaymentCheckoutLost";
import PaymentCheckoutSocialSwitch from "../../../components/Payment/PaymentCheckoutSocialSwitch";
import PaymentCheckoutCriticalSwitch from "../../../components/Payment/PaymentCheckoutCriticalSwitch";
import PaymentCheckoutLostSwitch from "../../../components/Payment/PaymentCheckoutLostSwitch";
import { CircularProgress } from "@mui/material";
import { getToken } from "../../../utils/auth";
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next";
import { t } from "i18next";

const PlanCard = ({ plan, currencySymbol }) => {
  const formatFeatureName = (name) => {
    return name
      ?.replace(/([A-Z])/g, " $1")
      .trim()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
 
  const renderFeatures = (features) => {
    return (
      <ul>
        {features?.map(([feature, value]) => (
          <div key={feature} style={{ fontSize: "18px" }}>
            {/* {value ? (
              <span style={{ color: "green", fontSize: "20px" }}>✔</span>
            ) : (
              <span style={{ color: "red", fontSize: "20px" }}>❌</span>
            )}{" "} */}
            {/* {formatFeatureName(feature)} */}
          </div>
        ))}
      </ul>
    );
  };

  const trueFeatures = [];
  const falseFeatures = [];
  for (const [feature, value] of Object.entries(plan)) {
    if (typeof value === "boolean" && feature !== "isDeleted") {
      if (value) {
        trueFeatures.push([feature, value]);
      } else {
        falseFeatures.push([feature, value]);
      }
    }
  }

  return (
    <Card
      style={{
        width: "95%",
        border: "1px solid #a5a5a5",
        margin: "10px",
        overflowX: "hidden",
      }}
    >
      <Card.Body
        style={{
          backgroundColor: `${plan?.isEnrolled ? "#ff9b8a" : ""}`,
        }}
      >
        <Card.Title style={{ fontSize: "24px", textAlign: "Center" }}>
          {plan?.planName}
        </Card.Title>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("priceFirstMonth")}:</strong>
          {currencySymbol} {plan?.firstYearPerMonthRate}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("annualPriceSecondYear")}:</strong> {currencySymbol}{" "}
          {plan?.secondYearAnnualRenewPrice}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("dynamicQrCount")}:</strong> {plan?.dynamicQRCount}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("smsCount")}:</strong> {plan?.smsCount}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("whatsappCount")}:</strong> {plan?.whatsappCount}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("planType")}:</strong> {plan?.planType}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("features")}:</strong>
          <ul>
            {plan?.features?.map((feature, index) => (
              <li key={index} style={{ fontSize: "18px" }}>
                {formatFeatureName(feature)}
              </li>
            ))}
          </ul>
          {/* <div>
            {renderFeatures(trueFeatures)}
            {renderFeatures(falseFeatures)}
            </div> */}
        </Card.Text>
        {plan?.isEnrolled && (
          <>
            <hr />
            <span
              style={{
                color: "green",
                fontSize: "20px",
                justifyContent: "center",
                display: "flex",
              }}
            >
              ✔ {t("enrolled")}
            </span>
          </>
        )}
        {/* {!plan?.isEnrolled && (
          <Button className="px-3" style={{ margin: "auto", display:"flex" }}>
            Buy Now
          </Button>
        )} */}
      </Card.Body>
    </Card>
  );
};

const Plans = () => {
    const { t, i18n } = useTranslation();
  
  const [plans, setPlans] = React.useState([]);
  const [tabValue, setTabValue] = React.useState(0)
  const [loadingFull, setLoadingFull] = React.useState(false);
  
  const defaultCurrency = "USD";
  const defaultSymbol = "$";
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency") || defaultCurrency
  );
  const [currencySymbol, setCurrencySymbol] = useState(
    localStorage.getItem("currencySymbol") || defaultSymbol
  );
  React.useEffect(() => {
    fetchPlans("social-net");
  }, [selectedCurrency]);

  const [user, setUser] = useState("");
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchPlans = async (platform) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/plan/all?platform=${platform}&currency=${selectedCurrency}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(
        `Plans Fetched Successfully for ${platform}`,
        response.data.data
      );
      setPlans(response.data.data || []);
    } catch (error) {
      console.log(`Failed fetching Plans for ${platform}`, error);
      setPlans([]); // Set to empty array if there's an error
    }
  };

  useEffect(() => {
    const savedCurrency = localStorage.getItem("selectedCurrency");
    if (user?.isCookieConsent) {
      Cookies.set("currency", savedCurrency, { expires: 30 });
    }
    if (!localStorage.getItem("selectedCurrency")) {
      localStorage.setItem("selectedCurrency", defaultCurrency);
      if (user?.isCookieConsent) {
        Cookies.set("currency", defaultCurrency, { expires: 30 });
      }
    }
    if (!localStorage.getItem("currencySymbol")) {
      localStorage.setItem("currencySymbol", defaultSymbol);
    }

    const fetchCurrencies = async () => {
      const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/data/currencies`;
      const authHeader =
        "Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=";

      try {
        setLoadingFull(true)
        const response = await axios.get(url, {
          headers: {
            Authorization: authHeader,
          },
        });
        setCurrencies(response.data);
        const savedCurrency = localStorage.getItem("selectedCurrency");
        const savedCurrencyData = response.data.find(
          (currency) => currency.code === savedCurrency
        );

        if (savedCurrencyData) {
          setCurrencySymbol(decodeHtmlEntity(savedCurrencyData.symbol));
        } else {
          setCurrencySymbol(defaultSymbol);
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
      } finally{
        setLoadingFull(false)
      }
    };

    fetchCurrencies();
  }, []);
    const cookiesPut = async (currency) => {
      try {
        const token = getToken();
        const response = await axios.put(
          `${process.env.REACT_APP_URL}/api/user/cookies`,
          {currency:currency},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("User preferences stored successfully")
      } catch (error) {
        console.log("Failed fetching connection", error);
      }
    };

  const handleCurrencyChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedCurrency(selectedCode);
    localStorage.setItem("selectedCurrency", selectedCode);
    if (user?.isCookieConsent) {
      Cookies.set("currency", selectedCode, { expires: 30 });
      cookiesPut(selectedCode);
    }
    const selectedCurrencyData = currencies.find(
      (currency) => currency.code === selectedCode
    );
    if (selectedCurrencyData) {
      const symbol = decodeHtmlEntity(selectedCurrencyData.symbol);
      setCurrencySymbol(symbol);
      localStorage.setItem("currencySymbol", symbol);
    }
  };

  const decodeHtmlEntity = (str) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        fetchPlans("social-net");
        break;
      case 1:
        fetchPlans("critical-D");
        break;
      case 2:
        fetchPlans("lost-and-found");
        break;
      default:
        break;
    }
  };



  return (<>
  {loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
    <div>
      <div
        style={{
          display: "flex",
          margin: "10px",
          gap: "10px",
          flexDirection: "row",
          justifyContent: "right",
          height: "50px",
          alignItems: "center",
        }}
      >
        <select
          value={selectedCurrency}
          onChange={handleCurrencyChange}
          style={{
            padding: "5px",
            fontSize: "16px",
            width: "200px",
            height: "40px",
          }}
        >
          <option value="" disabled>
            {t("selectCurrency")}
          </option>
          {currencies?.map((currency) => (
            <option key={currency?.code} value={currency?.code}>
              {currency?.name} ({decodeHtmlEntity(currency?.symbol)})
            </option>
          ))}
        </select>
        {tabValue === 0 ? (
          user?.isEnrolledInSocialNet ? (
            <PaymentCheckoutSocialSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>
          ) : (
            <PaymentCheckoutSocial selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>
          )
        ) : tabValue === 1 ? (
          user?.isEnrolledInCriticalD ? (
            <PaymentCheckoutCriticalSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>
          ) : (
            <PaymentCheckoutCritical selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>
          )
        ) : user?.isEnrolledInLostAndFound ? (
          <PaymentCheckoutLostSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>
        ) : (
          <PaymentCheckoutLost selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>
        )}
      </div>
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Tabs value={tabValue} onChange={handleTabChange} centered variant="scrollable"
                          scrollButtons="auto">
          <Tab label={t("qr_hero")} />
          <Tab label={t("critical_d")} />
          <Tab label={t("lost_and_found")} />
        </Tabs>
      </Box>

      {plans.length > 0 ? (
        <Row>
          {plans.map((plan, index) => (
            <Col key={index} xs={12} md={6}>
              <PlanCard plan={plan} currencySymbol={currencySymbol} />
            </Col>
          ))}
        </Row>
      ) : (
        <div
          style={{ textAlign: "center", marginTop: "20px", fontSize: "20px" }}
        >
          {t("noPlansAvailable")}
        </div>
      )}
    </div>
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};


export default Plans;
